(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ChangeTableDialogController', ChangeTableDialogController);

    ChangeTableDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ChangeTable'];

    function ChangeTableDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ChangeTable) {
        var vm = this;
        vm.changeTable = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:changeTableUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.changeTable.id !== null) {
                ChangeTable.update(vm.changeTable, onSaveSuccess, onSaveError);
            } else {
                ChangeTable.save(vm.changeTable, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
